var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffac3c",
    d: "M20.001 40a19.868 19.868 0 01-14.142-5.858A19.868 19.868 0 01.001 20 19.868 19.868 0 015.859 5.858 19.868 19.868 0 0120.001 0a19.87 19.87 0 0114.142 5.858A19.87 19.87 0 0140.001 20a19.87 19.87 0 01-5.858 14.142A19.87 19.87 0 0120.001 40zm.1-30.213L9.791 19.825h5.836v8.686h8.753v-8.686h5.836L20.101 9.787z"
  })));
}
export default SvgUpload;